import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"

import { formatDateDataGrid } from "src/utils/format-date"
import { DATE_FORMAT_SHOW } from "src/utils/constants"

import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaRecompraProgramadaTable = (props) => {
    const datalakeService = new DatalakeService()

    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({
        count: 0,
        next: null,
        previous: null
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .catch(props.callbackError)
            .finally(() => props.loading(false))
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            IDEmissao,
            CETIP,
            RendaFixaCaracteristicasID,
            IDRecompraProgramada,
            VersaoDocumento,
            DataReferencia,
            DataRecompraProgramada
        } = newRow

        const body = {
            RendaFixaCaracteristicasID,
            IDEmissao,
            CETIP,
            IDRecompraProgramada,
            VersaoDocumento,
            DataReferencia,
            DataRecompraProgramada
        }

        props.loading(true)

        return datalakeService
            .updateTableEndpoint(props.endpoint, ID, body)
            .catch((err) => {
                props.loading(false)
                throw err
            })
            .finally(() => props.loading(false))
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint, query, limit, offset)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        datalakeService
            .paginate(endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            minWidth: 80,
            disableColumnMenu: true,
            disableFilter: true
        },
        {
            field: 'RendaFixaCaracteristicasID',
            headerName: 'RendaFixaCaracteristicasID',
            type: 'number',
            minWidth: 200,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'IDRecompraProgramada',
            headerName: 'ID Recompra Programada',
            type: 'number',
            minWidth: 200,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'IDEmissao',
            headerName: 'ID Emissão',
            minWidth: 200,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            minWidth: 160,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'VersaoDocumento',
            headerName: 'Versao Documento',
            type: 'number',
            minWidth: 150,
            editable: true,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'DataReferencia',
            headerName: 'Data Referência',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'DataRecompraProgramada',
            headerName: 'Data Recompra Programada',
            minWidth: 200,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            updateRow={updateRow}
            pagination={pagination}
            onChangePage={changePage}
            filterFunction={onFilter}
            customFilter={true}
            useDeleteButton={false}
        />
    )
}

ParameterEmissaoRendaFixaRecompraProgramadaTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaRecompraProgramadaTable
